import YesIcon from 'assets/images/yes-icon.svg';
import SuccessImage from 'assets/images/create-success.svg';
import CancelRenewalImage from 'assets/images/cancel-renewal-v2.svg';
import CanceSubslImage from 'assets/images/sad-smiley.svg';
import ThumbsupImage from 'assets/images/thumbsup-smiley.svg';
import Logo from 'assets/images/logo.svg';
import FooterLogo from 'assets/images/footer-logo.svg';
import loginLogo from 'assets/images/login-logo.png';
import SubscribiliLogoDark from 'assets/images/logo-subscribili-dark.png';
import Theme from 'theme';

const {
  REACT_APP_GROUP_ID: groupId,
  REACT_APP_AWS_REGION: region,
  REACT_APP_COGNITO_POOL_ID: userPoolId,
  REACT_APP_COGNITO_WEB_CLIENT_ID: userPoolWebClientId,
  REACT_APP_CLIENT_HEADER: clientHeader = groupId,
  REACT_APP_APPPOINTMENT_LINK: bookAppointmentLink,
} = process.env;

const config = {
  groupId,
  region,
  userPoolId,
  userPoolWebClientId,
  logo: Logo,
  cptCodesIcon: YesIcon,
  portalName: 'Apex Longevity',
  // Industry drives the Strapi FAQ template (SAP-7671). Omit to default to 'dental'.
  // Valid: dental | primary-care | chiropractic | dermatology | urgent-care | veterinary
  industry: 'chiropractic',
  tokenName: 'apexlongevitySubscriberToken',
  globalClass: 'group-parent-container',
  clientHeader,
  enableHeroButton: true,
  pricingType: 'standard-pricing',
  showAddressSuggestion: true,
  heroLocaleColor: 'secondary',
  splitPlans: false,
  headerProps: {
    enable: true,
  },
  localeProps: {},
  homeTemplateProps: {
    heroSection: {
      variant: 2,
      titleClasses: 'home-hero-title',
      subTitleClasses: 'home-hero-subtitle',
      primaryButtonProps: {
        color: 'secondary',
      },
      secondaryButtonProps: {
        to: '/login',
        color: 'secondary',
      },
      background: '/images/home-images/home-banner-img.webp',
      backgroundMobile: '/images/home-images/home-banner-tab.webp',
      verticalAlignImage: 'bottom',
    },
    benefitsSection: {
      enable: true,
      definitionPosition: 'top',
      variant: 6,
      columns: 3,
      alignTitle: 'left',
      alignCard: 'left',
    },
    membershipValueSection: {
      enable: true,
      position: 'top',
    },
    freebieSection: {
      enable: true,
      position: 'top',
      heroImage: '/images/home-images/treatment-band.webp',
    },
    subscriptionSection: {
      variant: 1,
      showFrequencyPills: true,
      renderAsTabsLimit:4,
      cardVariant: 1,
      tabVariant: 1,
      disableGroupSavings: true,
      autoPlanLayout: true,
      plansPerRow: { xs: 1, sm: 1, md: 3, lg: 3 },
      carouselResponsiveItems: {
        desktop: 3,
      },
      showAddons: false,
      primaryButtonProps: {
        color: 'primary',
      },
      planCardProps: {
        buttonProps: {
          customSpace: 11,
          normalVariant: 'outlined',
          normalColor: 'primary',
          highlightedVariant: 'contained',
          highlightedColor: 'primary',
          to: '/find-a-provider',
        },
      },
    },
    howItWorksSection: {
      variant: 3,
      heroImage: '/images/home-images/how-it-works.webp',
      alignTitle: 'center',
    },
    testimonialSection: {
      enable: false,
    },
    faqSection: {
      enable: true,
      variant: 2,
      buttonProps: {
        enable: true,
        align: 'left',
        text: 'Get Started',
        scrollTo: 'pricing-benefit-section',
        variant: 'contained',
        color: 'primary',
      },
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      primaryButtonProps: {
        color: 'secondary',
      },
    },
  },
  checkoutSection: {},
  findProviderSection: {
    locationWrapper: 7,
    mapWrapper: 5,
    iconProps: {
      url: '/images/location-marker.png',
      width:30,
      height: 30,
    },
  },
  choosePlanSection: {
    sectionSubtitle: '',
    locationLogo: Logo,
    cardVariant: 1,
    tabVariant: 2,
    planCardProps: {
      buttonProps: {
        normalColor: 'primary',
        highlightedColor: 'primary',
        normalVariant: 'contained',
        highlightedVariant: 'outlined',
      },
    },
    staticHeroSection: {
      enable: true,
      variant: 1,
      primaryButtonProps: {
        color: 'primary',
      },
    },
  },
  subscriptionSuccess: {
    successImage: SuccessImage,
    enableBookAppointment: false,
  },
  savingsSummary: {
    enableFooterbar: true,
    showCategoryHeaders: true, // Deprecated: no longer used
    showPlanDiscHeader: false, // Deprecated: no longer used
    contactSection: 'contactDetails',
    buttonProps: {
      variant: "outlined",
      color: "secondary",
      size: "large",
    },
  },
  faqSection: {},
  dashboardProps: {
    showBenefitsUsage: true,
    showFeeSchedule: false,
    cancelRenewal: {
      image: CancelRenewalImage,
    },
    cancelSubscription: {
      image: CanceSubslImage,
    },
    reactivateRenewal: {
      image: ThumbsupImage,
    },
  },
  bookAppointment: {},
  footer: {
    enable: true,
    logo: FooterLogo,
    subscribiliLogo: SubscribiliLogoDark,
    topBanner: {
      enable: true,
    },
  },
  loginPage: {
    bannerImage: './images/login.webp',
    logo: loginLogo,
  },
  theme: Theme,
};

export default config;
